import { useSyncExternalStore } from 'react';
import {
  getKnownClusters,
  subscribeKnownClusters,
  type KnownClustersSnapshot,
} from '@/utils/clusterReconcile';

/**
 * STORY-300: the live clusters (id, name, @slug) the ClusterModeSelector last
 * fetched, re-rendering when they change. Transient — never persisted.
 */
export function useKnownClusters(): KnownClustersSnapshot {
  return useSyncExternalStore(subscribeKnownClusters, getKnownClusters, getKnownClusters);
}
